import React, { useEffect, useState } from "react";
import { GetMarketingMaterialForFilterType } from "../../../models/_marketingMaterial";
import { INSTALLATION_JOB_STORAGE_KEY } from "../InstallationJob";

const MarketingMaterials = ({
  materialDB,
  jobStatus,
  installationJobDB,
}: {
  materialDB: GetMarketingMaterialForFilterType[];
  jobStatus: string;
  installationJobDB: any;
}) => {
  const [selectedMarketingMaterials, setSelectedMarketingMaterials] = useState<string[]>([]);

  // 🔹 Load saved selection from localStorage on first render
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem(INSTALLATION_JOB_STORAGE_KEY) || "{}");
    const savedMaterials: string[] =
      storedData?.locationInformation?.selectedMarketingMaterials || [];
  
    if (savedMaterials.length > 0) {
      // ✅ Use localStorage values first
      setSelectedMarketingMaterials(savedMaterials);
      return; // stop here, don't overwrite with DB
    }
  
    // Fallback: pre-populate from installationJobDB if localStorage empty
    if (jobStatus !== "Completed" && installationJobDB) {
      const dbMaterialIds: string[] = installationJobDB.marketingMaterials || [];
      setSelectedMarketingMaterials(dbMaterialIds);
  
      // Save initial DB data to localStorage
      const updatedData = {
        ...storedData,
        locationInformation: {
          ...storedData.locationInformation,
          selectedMarketingMaterials: dbMaterialIds,
        },
      };
      localStorage.setItem(INSTALLATION_JOB_STORAGE_KEY, JSON.stringify(updatedData));
    }
  }, [installationJobDB, jobStatus]);
  

  const handleCheckboxChange = (materialId: string | number) => {
    const idAsString = String(materialId); // ✅ force string

    setSelectedMarketingMaterials((prev) => {
      const updatedSelection = prev.includes(idAsString)
        ? prev.filter((id) => id !== idAsString)
        : [...prev, idAsString];

      // 🔹 Save updated selection in localStorage
      const storedData = JSON.parse(localStorage.getItem(INSTALLATION_JOB_STORAGE_KEY) || "{}");
      const updatedData = {
        ...storedData,
        locationInformation: {
          ...storedData.locationInformation,
          selectedMarketingMaterials: updatedSelection,
        },
      };
      localStorage.setItem(INSTALLATION_JOB_STORAGE_KEY, JSON.stringify(updatedData));

      return updatedSelection;
    });
  };

  return (
    <div className="accordion mt-4" id="marketingMaterialsAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="marketingMaterialsHeading">
          <button
            className="accordion-button collapsed py-5 fs-4 fw-bold bg-light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#marketingMaterialsCollapse"
          >
            Marketing Materials
          </button>
        </h2>
        <div id="marketingMaterialsCollapse" className="accordion-collapse collapse ">
          <div className="accordion-body">
            <div className="row">
              {materialDB.map((material, index) => (
                <div key={material.id} className="col-lg-6 col-md-6 col-12 mb-2">
                  <div className="form-check form-check-custom form-check-solid d-flex align-items-center">
                    <input
                      className="form-check-input mb-2 me-1"
                      type="checkbox"
                      id={`material_${index}`}
                      checked={selectedMarketingMaterials.includes(String(material.id))}
                      onChange={() => handleCheckboxChange(material.id)}
                    />
                    <label className="form-check-label fs-5" htmlFor={`material_${index}`}>
                      {material.name}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingMaterials;
